import React from "react";
import { observer } from "mobx-react";
import BreakpointStore from "../stores/BreakpointStore";
import { GalleryModel } from "../models/GalleryModel";
import FullGallery from "../components/Gallery/FullGallery";
import InlineGallery from "../components/Gallery/InlineGallery";

interface GalleryState {
  breakpoint: BreakpointStore;
}

interface GalleryProps {
  fullGalleryMode?: boolean;
  content: GalleryModel[];
}

@observer
class Gallery extends React.Component<GalleryProps, GalleryState> {
  constructor(props: GalleryProps) {
    super(props);

    this.state = {
      breakpoint: new BreakpointStore()
    };
  }

  render() {
    const { fullGalleryMode, content } = this.props;
    return (
      <div>
        {this.state.breakpoint.isMobile && !fullGalleryMode ? (
          <InlineGallery content={content} />
        ) : (
          <FullGallery content={content} fullGalleryMode={fullGalleryMode} />
        )}
      </div>
    );
  }
}

export default Gallery;
